module.exports = __webpack_public_path__ + "assets/img/swiper-img1-055f18b9.png";